import { Pipe, PipeTransform } from "@angular/core";
import type { ClareStatus } from "@app/shared/model/clare-status.model";
import { occupiedStatus, vacantStatus } from "@app/shared/model/clare-status.model";

@Pipe({ name: "occupationStatus" })
export class OccupationStatusPipe implements PipeTransform {
    transform(isUnitOccupied: boolean): ClareStatus {
        return isUnitOccupied ? occupiedStatus : vacantStatus;
    }
}
